import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListNegara } from "@/services/getData"

export default function MasterNegaraPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listNegara"],
    queryFn: getListNegara,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
